import React from "react";

function ClientReviews() {
  return (
    <section id="reviewss">
        <div className="google-review-lg">
          <div
            className="elfsight-app-37369e5f-3b2a-47a8-bf0b-7603b22c71fa"
            data-elfsight-app-lazy
          ></div>
        </div>

           </section>
  );
}

export default ClientReviews;
 {/* <section className="bg-light py-3 py-md-5">
          <div className="container">
            <div className="row gy-5 gy-lg-0 align-items-center">
              <div className="col-12 col-lg-4">
                <h2 className="display-2 mb-3 mb-xl-4">Our Happy Clients</h2>
                <p className="lead mb-4 mb-xl-5">
                  We believe in client satisfaction. Here are some testimonials
                  by our worthy clients.
                </p>
              </div>
              <div className="col-12 col-lg-8">
                <div className="row justify-content-xl-end">
                  <div className="col-12 col-xl-11">
                    <div className="row gy-4">
                      <div className="col-12 col-md-6">
                        <div className="card border-0 border-bottom border-primary shadow-sm">
                          <div className="card-body p-4 p-xxl-5">
                            <figure>
                              <figcaption>
                                <blockquote className="bsb-blockquote-icon mb-4">
                                  "Bsecure Advisory Services truly understands
                                  the financial challenges faced by small
                                  businesses. Their tailored solutions and deep
                                  connections with various banks helped me
                                  secure the best loan for my business. They
                                  simplified the entire process, and I couldn’t
                                  be happier with their service."
                                </blockquote>
                                <h4 className="mb-2">Durai Selvan</h4>
                                <h5 className="fs-6 text-warning mb-0">
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>
                                </h5>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="card border-0 border-bottom border-primary shadow-sm">
                          <div className="card-body p-4 p-xxl-5">
                            <figure>
                              <figcaption>
                                <blockquote className="bsb-blockquote-icon mb-4">
                                  "I was struggling with my credit profile, and
                                  Bsecure Advisory Services turned things around
                                  for me. Their team crafted a financial
                                  strategy that not only improved my credit
                                  score but also helped me secure a loan with
                                  favorable terms. Highly recommend them!"
                                </blockquote>
                                <h4 className="mb-2">Priya</h4>
                                <h5 className="fs-6 text-warning mb-0">
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>
                                </h5>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="card border-0 border-bottom border-primary shadow-sm">
                          <div className="card-body p-4 p-xxl-5">
                            <figure>
                              <figcaption>
                                <blockquote className="bsb-blockquote-icon mb-4">
                                  "Working with Bsecure Advisory has been a
                                  game-changer for our company. Their expertise
                                  in financial products is unmatched, and their
                                  connections with a wide range of banks allowed
                                  us to explore options we never thought
                                  possible. They’ve become a trusted financial
                                  partner for us."{" "}
                                </blockquote>
                                <h4 className="mb-2">Rajesh Mehra</h4>
                                <h5 className="fs-6 text-warning mb-0">
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-half"></i>{" "}
                                </h5>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="card border-0 border-bottom border-primary shadow-sm">
                          <div className="card-body p-4 p-xxl-5">
                            <figure>
                              <figcaption>
                                <blockquote className="bsb-blockquote-icon mb-4">
                                  "The personalized service I received from
                                  Bsecure Advisory was top-notch. From
                                  understanding my business goals to finding the
                                  right financial product, they guided me every
                                  step of the way. Their extensive network of
                                  banks and NBFCs gave me access to the best
                                  deals in the market."{" "}
                                </blockquote>
                                <h4 className="mb-2">Anita Joshi </h4>
                                <h5 className="fs-6 text-warning mb-0">
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>{" "}
                                  <i class="bi bi-star-fill"></i>
                                </h5>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        
